export type BackgroundJobStatus =
  | "pending"
  | "running"
  | "completed"
  | "failed"
  | "cancelled";

export type BackgroundJobType = "weekly_coaching_report";

export interface BackgroundJob {
  id: string;
  tenant_id: string;
  user_id: string;
  scheduled_job_id: string | null;
  job_type: BackgroundJobType;
  status: BackgroundJobStatus;
  parameters: Record<string, unknown>;
  outcome: Record<string, unknown> | null;
  started_at: string | null;
  completed_at: string | null;
  created: string;
  modified: string;
}

export interface CoachingReportDocument {
  name: string;
  text: string;
}

// content.documents[].name identifiers shared with the backend. Mirrors
// the constants in supabase/functions/_shared/coaching/types.ts — keep
// both sides in sync.
export const DOCUMENT_NAME_AGENT_SCORECARDS_SUMMARY = "agentScorecardsSummary";
export const DOCUMENT_NAME_TEAM_BENCHMARKS = "teamBenchmarks";

// Mirrors the backend CoachingJobParameters in
// supabase/functions/background-jobs/actions/coaching-dispatch.ts.
// Both definitions describe the same submit payload and must stay in sync.
export interface WeeklyCoachingReportParameters {
  tenant_id: string;
  user_id: string;
  agent_email: string;
  agent_display_name?: string;
  lens_name: string;
  lens_path?: string;
  time_range: string;
  timezone: string;
  // Epoch ms — wizard derives from time_range so backend doesn't need a
  // time-range parser.
  started_timestamp: number;
  ended_timestamp: number;
  // Pre-rendered markdown the wizard built via markdownConverter.
  // Typically agentScorecardsSummary + teamBenchmarks.
  documents: CoachingReportDocument[];
  selected_attributes: string[];
  custom_prompt?: string;
  system_prompt: string;
  coaching_hub_title?: string;
  model: string;
  temperature: number;
  max_tokens: number;
}

export interface SubmitJobResponse {
  job_id: string;
  status: BackgroundJobStatus;
  message: string;
}
